namespace Matrix.Rebalancer {
    export interface ModellingViewFormatForm {
        ColumnSetCode: Serenity.StringEditor;
        SortOrder: Serenity.IntegerEditor;
        Expression: Serenity.StringEditor;
        FieldName: Serenity.StringEditor;
        BackColour: ColorPicker;
        ForeColour: ColorPicker;
        FontSize: Serenity.DecimalEditor;
        FontBold: Serenity.BooleanEditor;
        FontItalic: Serenity.BooleanEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ModellingViewFormatForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.ModellingViewFormat';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ModellingViewFormatForm.init)  {
                ModellingViewFormatForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = ColorPicker;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(ModellingViewFormatForm, [
                    'ColumnSetCode', w0,
                    'SortOrder', w1,
                    'Expression', w0,
                    'FieldName', w0,
                    'BackColour', w2,
                    'ForeColour', w2,
                    'FontSize', w3,
                    'FontBold', w4,
                    'FontItalic', w4,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
